import { buildService } from './decorated-service';
import { handleBankRoutingNumberError } from './util';

const bankRoutingNumberService = buildService(
  '/nasu-svc/service/validation/bank-routing-number'
);

export const verifyBankRoutingNumber = (
  routingNumber: string
): Promise<any> => {
  return bankRoutingNumberService.add(
    { value: routingNumber },
    { handleServiceResponse: handleBankRoutingNumberError }
  );
};
